export const bookingTools = [
  {
    type: "function",
    function: {
      name: "get_organization",
      description: "Get the organization this chat is booking for.",
      parameters: {
        type: "object",
        properties: {
          orgId: {
            type: "string",
            description: "Selected organization ID. Organization ID is only required when user selects an organization after using find_organizations tool",
          },
        },
        additionalProperties: false,
      },
    },
  },
  {
    type: "function",
    function: {
      name: "find_organizations",
      description:
        "Search for organizations that match the customer-provided organization name. Use this tool only after the customer provides an organization name or search term. The result is used to identify the organization for which the customer wants to make a booking.",
      parameters: {
        type: "object",
        properties: {
          searchText: {
            type: "string",
            description:
              "The organization name or search term provided by the customer. Use the customer's input as the search text without adding or changing details.",
          },
        },
        required: ["searchText"],
        additionalProperties: false,
      },
    },
  },
  {
    type: "function",
    function: {
      name: "list_services",
      description: "List real services offered by the organization. When the organization uses products, provide the selected product ID to list only services available for that product. Product-level service metadata such as description, tags, and price may override service defaults.",
      parameters: {
        type: "object",
        properties: {
          productId: {
            type: "string",
            description: "Selected product ID. Required when organization.preferences.enableProducts is true.",
          },
        },
        additionalProperties: false,
      },
    },
  },
  {
    type: "function",
    function: {
      name: "list_products",
      description: "List products offered by a product-based organization. Each product must be selected before listing its available services.",
      parameters: {
        type: "object",
        properties: {},
        additionalProperties: false,
      },
    },
  },
  {
    type: "function",
    function: {
      name: "list_schedules",
      description: "List schedules/providers/locations for a selected service. When a product-specific service price is available, that product pricing should take precedence over schedule-level pricing.",
      parameters: {
        type: "object",
        required: ["serviceId"],
        properties: {
          serviceId: {
            type: "string",
            description: "The selected service ID.",
          },
          productId: {
            type: "string",
            description: "Selected product ID. Use this to override schedule pricing when the product service has its own price details.",
          },
        },
        additionalProperties: false,
      },
    },
  },
  {
    type: "function",
    function: {
      name: "list_available_dates",
      description: "List dates that have available slots for a selected schedule.",
      parameters: {
        type: "object",
        required: ["scheduleId"],
        properties: {
          scheduleId: {
            type: "string",
            description: "The selected schedule/temporary service ID.",
          },
        },
        additionalProperties: false,
      },
    },
  },
  {
    type: "function",
    function: {
      name: "list_available_slots_by_date",
      description: "List available time slots for a selected schedule on a selected date.",
      parameters: {
        type: "object",
        required: ["scheduleId", "date"],
        properties: {
          scheduleId: {
            type: "string",
            description: "The selected schedule/temporary service ID.",
          },
          date: {
            type: "string",
            description: "Selected date in YYYY-MM-DD format.",
          },
        },
        additionalProperties: false,
      },
    },
  },
  {
    type: "function",
    function: {
      name: "book_appointment",
      description: "Create a guest customer if needed and book the selected appointment or queue slot after explicit customer confirmation.",
      parameters: {
        type: "object",
        required: ["customerName", "customerPhone", "serviceId", "scheduleId", "availabilityId", "startSec"],
        properties: {
          customerName: {
            type: "string",
            description: "Customer full name.",
          },
          customerPhone: {
            type: "string",
            description: "Customer phone number.",
          },
          customerEmail: {
            type: "string",
            description: "Customer email address, if provided.",
          },
          serviceId: {
            type: "string",
            description: "Selected service ID.",
          },
          scheduleId: {
            type: "string",
            description: "Selected schedule/temporary service ID.",
          },
          productId: {
            type: "string",
            description: "Selected product ID.",
          },
          availabilityId: {
            type: "string",
            description: "Selected slot availability ID.",
          },
          startSec: {
            type: "number",
            description: "Selected slot start time in Unix seconds.",
          },
          additionalInfoFormData: {
            type: "object",
            description: "Additional info form filled by the customer",
          },
        },
        additionalProperties: false,
      },
    },
  },
  {
    type: "function",
    function: {
      name: "verify_otp",
      description: "Verify the booking OTP for the given mobile number.",
      parameters: {
        type: "object",
        required: ["mobileNumber", "otp"],
        properties: {
          mobileNumber: {
            type: "string",
            description: "Customer phone number.",
          },
          otp: {
            type: "string",
            description: "One-time password sent to the customer's phone number for verification.",
          },
        },
        additionalProperties: false,
      },
    },
  },
];
